<template>
    <div>
        <slot>
            <div class="border-gray-200 border-b text-center text-2xl font-normal py-5">
                Special Offers
            </div>
        </slot>
        <div class="pb-5" :style="{ 'background-image': special ? `url('/images/confetti.png')` : '' }"
             style="background-size: cover;">
            <div class="mx-auto md:w-2/3 lg:w-1/2 xl:w-1/3 2xl:w-1/4 px-5 pt-4">
                <div v-if="special" class="text-sm relative z-10 text-center faded p-4 rounded-lg"
                     style="border: 2px solid #638197; background-color: #F3FAFF;">
                    Original Balance: {{ account.original_balance | money }}
                </div>
                <template v-if="! offers.length && ! offer">
                    <div class="p-4 flex flex-col justify-center text-center">
                        <svg class="w-10 h-10 w-full fa-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                             xmlns="http://www.w3.org/2000/svg">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
                        </svg>

                        <span class="mt-4">We are gathering the best offers for you one moment...</span>
                    </div>
                </template>
                <template v-else v-for="offerItem in sortedOffers">

                    <template v-if="special">

                        <a v-if="offerItem.type === 'full-settlement'"
                           :id="offerItem.name"
                           @click.prevent="$emit('select', offerItem)"
                           class="block mt-4 relative z-10 faded p-7 text-center cursor-pointer rounded-lg"
                           style="border: 2px solid #F0BDA4; background-color: #FFF7F3; box-shadow: 0 10px 17px -10px #F5E8E1;">
                            <div class="flex justify-center">
                                <p class="flex-initial text-sm bg-yellow-200 font-semibold py-1 px-4 rounded-full">Most
                                    Popular</p>
                            </div>
                            <p class="text-xl mt-4 font-medium">
                                <template
                                    v-if="!offerItem.plan.max_payment_choices || offerItem.plan.max_payment_choices === 1">
                                    Pay {{ offerItem.offer | money }}
                                </template>
                                <template v-if="offerItem.plan.max_payment_choices === 2">
                                    Pay {{ offerItem.offer | money }} in 1 or 2 payments
                                </template>
                                <template v-if="offerItem.plan.max_payment_choices > 2">
                                    Pay {{ offerItem.offer | money }} in up to
                                    {{ offerItem.plan.max_payment_choices }} payments
                                </template>
                            </p>
                            <p class="text-sm mt-1 font-medium" v-if="offerItem.discount > 0">
                                {{ offerItem.discount }}% off, Save {{ offerItem.savings | money }}
                            </p>
                        </a>

                        <a v-if="offerItem.type === 'settlement-payments' && !offerItem.plan.choose_payments"
                           :id="offerItem.name"
                           @click.prevent="$emit('select', offerItem)"
                           class="block mt-4 relative z-10 faded p-7 text-center cursor-pointer rounded-lg"
                           style="border: 2px solid #F0BDA4; background-color: #FFF7F3; box-shadow: 0 10px 17px -10px #F5E8E1;">
                            <div class="flex justify-center">
                                <p class="flex-initial text-sm bg-yellow-200 font-semibold py-1 px-4 rounded-full">Most
                                    Popular</p>
                            </div>
                            <p class="text-xl mt-4 font-medium">
                                {{ offerItem.plan.payments }} Payments
                            </p>
                            <p class="text-sm mt-1 font-medium" v-if="offerItem.discount > 0">
                                {{ offerItem.discount }}% off, Save {{ offerItem.savings | money }}
                            </p>
                        </a>

                        <a @click.prevent="$emit('select', offerItem)"
                           :id="offerItem.name"
                           v-else-if="offerItem.type === 'settlement-payments' && offerItem.plan.choose_payments"
                           class="block z-10 relative bg-white mt-4 faded border p-7 text-center cursor-pointer bg-white border-gray-300 rounded-lg">
                            <p class="text-xl font-medium">Monthly Payments</p>
                            <p class="text-sm mt-1 font-medium">
                                <template>
                                    Up to 12 Months
                                </template>
                            </p>
                            <p class="text-sm mt-1 font-medium" v-if="offerItem.discount > 0">
                                {{ offerItem.discount }}% off, Save {{ offerItem.savings | money }}
                            </p>
                        </a>

                        <a @click.prevent="$emit('select', offerItem)"
                           :id="offerItem.name"
                           v-else-if="offerItem.type === 'custom'"
                           class="block z-10 relative bg-white mt-4 faded border p-7 text-center cursor-pointer bg-white border-gray-300 rounded-lg">
                            <p class="text-xl font-medium">Monthly Payments</p>
                            <p class="text-sm mt-1 font-medium">
                                Enter your own payment amount
                            </p>

                            <p class="text-sm mt-1 font-medium">
                                Flexible payments on the Total Balance of {{ account.current_balance | money }}
                            </p>
                        </a>
                    </template>

                    <template v-else>
                        <template v-if="offerItem.type === 'full-settlement'">
                            <a @click.prevent="$emit('select', offerItem)"
                                :id="offerItem.name"
                                class="block mt-2 relative z-10 faded border p-4 rounded-lg text-center cursor-pointer"
                                :class="{
                                    'bg-white border-gray-300': ! selectedOffer || selectedOffer.name !== offerItem.name,
                                    [`bg-${$root.theme}-50 border-${$root.theme}-700`]: selectedOffer && selectedOffer.name === offerItem.name
                                }">
                                <p :class="`text-base text-${$root.theme}-700 font-semibold leading-snug`">
                                    <template
                                        v-if="!offerItem.plan.max_payment_choices || offerItem.plan.max_payment_choices === 1">
                                        Pay {{ offerItem.payment | money }}
                                    </template>
                                    <template v-if="offerItem.plan.max_payment_choices === 2">
                                        Pay {{ offerItem.payment | money }} in 1 or 2 payments
                                    </template>
                                    <template v-if="offerItem.plan.max_payment_choices > 2">
                                        Pay {{ offerItem.payment | money }} in up to
                                        {{ offerItem.plan.max_payment_choices }} payments
                                    </template>
                                </p>
                                <p class="text-sm font-medium"
                                   :class="{ [`text-${$root.theme}-500`]: ! selectedOffer || selectedOffer.name === offerItem.name, 'text-gray-500': selectedOffer && selectedOffer.name !== offerItem.name }"
                                   v-if="offerItem.discount > 0">
                                    {{ offerItem.discount }}% off, that's a savings of {{ offerItem.savings | money }}!
                                </p>
                            </a>
                            <div v-if="! offer && ! offerItem.plan.hasOwnProperty('additional_percentage_off')"
                                 :class="`bg-${$root.theme}-700 border-${$root.theme}-700 text-white faded z-0 relative -top-2 -mb-2 border p-1 pt-3 rounded-b-lg text-center`">
                                <p class="text-xs" v-text="mostPopularSubtext"/>
                            </div>
                            <div v-else-if="! offer && offerItem.plan.hasOwnProperty('additional_percentage_off')"
                                 :class="`bg-${$root.theme}-700 border-${$root.theme}-700 text-white faded z-0 relative -top-2 -mb-2 border p-1 pt-3 rounded-b-lg text-center`">
                                <p class="text-xs">
                                    Bigger Discount, Fewer Payments!
                                </p>
                            </div>
                        </template>

                        <a @click.prevent="$emit('select', offerItem)"
                           :id="offerItem.name"
                           v-else-if="offerItem.type === 'full-settlement-with-dp'"
                           class="block mt-2 faded border p-4 rounded-lg text-center cursor-pointer"
                           :class="{
                                'bg-white border-gray-300': ! selectedOffer || selectedOffer.name !== offerItem.name,
                                [`bg-${$root.theme}-50 border-${$root.theme}-700`]: selectedOffer && selectedOffer.name === offerItem.name
                            }">
                            <p :class="`text-base text-${$root.theme}-700 font-semibold leading-snug`">
                                <template
                                    v-if="!offerItem.plan.max_payment_choices || offerItem.plan.max_payment_choices === 1">
                                    Pay {{ offerItem.payment | money }}
                                </template>
                                <template v-if="offerItem.plan.max_payment_choices === 2">
                                    Pay {{ offerItem.payment | money }} in 1 or 2 payments
                                </template>
                                <template v-if="offerItem.plan.max_payment_choices > 2">
                                    Pay {{ offerItem.payment | money }} in up to
                                    {{ offerItem.plan.max_payment_choices }} payments
                                </template>
                            </p>
                            <p :class="`text-base text-${$root.theme}-700 font-bold leading-snug`">
                                With down payment of {{ offerItem.down_payment | money }}
                            </p>
                            <p class="text-sm"
                               :class="{ [`text-${$root.theme}-500`]: selectedOffer && selectedOffer.name === offerItem.name, 'text-gray-500': selectedOffer && selectedOffer.name !== offerItem.name }">
                                On total balance of {{ account.current_balance | money }}
                            </p>
                        </a>

                        <template v-else-if="offerItem.type === 'sliding-scale'">
                            <a @click.prevent="$emit('select', offerItem)"
                                :id="offerItem.name"
                                class="block mt-2 relative z-10 faded border p-4 rounded-lg text-center cursor-pointer"
                                :class="{
                                    'bg-white border-gray-300': ! selectedOffer || selectedOffer.name !== offerItem.name,
                                    [`bg-${$root.theme}-50 border-${$root.theme}-700`]: selectedOffer && selectedOffer.name === offerItem.name
                                }">
                                <p :class="`text-base text-${$root.theme}-700 font-semibold leading-snug`">
                                    Pay {{ offerItem.payment | money }}
                                    in up to
                                    {{ offerItem.plan.max_payment_choices }}
                                    payments
                                </p>
                                <p class="text-sm font-medium"
                                   :class="{ [`text-${$root.theme}-500`]: selectedOffer && selectedOffer.name === offerItem.name, 'text-gray-500': selectedOffer && selectedOffer.name !== offerItem.name }">
                                    Popular Payment Plans
                                </p>
                            </a>
                            <div
                                :class="`bg-${$root.theme}-700 border-${$root.theme}-700 text-white faded z-0 relative -top-2 -mb-2 border p-1 pt-3 rounded-b-lg text-center`">
                                <p class="text-xs">Budget Friendly</p>
                            </div>
                        </template>

                        <template v-else-if="offerItem.type === 'full'">
                            <a @click.prevent="$emit('select', offerItem)"
                                :id="offerItem.name"
                                class="relative block mt-2 z-10 faded border p-4 rounded-lg text-center cursor-pointer"
                                :class="{
                                    'bg-white border-gray-300': ! selectedOffer || selectedOffer.name !== offerItem.name,
                                    [`bg-${$root.theme}-50 border-${$root.theme}-700`]: selectedOffer && selectedOffer.name === offerItem.name
                                }">
                                <p v-if="offerItem.plan && offerItem.plan.hasOwnProperty('max_payment_choices') && offerItem.plan.max_payment_choices > 1"
                                    :class="`text-base text-${$root.theme}-700 font-semibold leading-snug`">
                                    <template
                                        v-if="!offerItem.plan.max_payment_choices || offerItem.plan.max_payment_choices === 1">
                                        Pay {{ offerItem.payment | money }}
                                    </template>
                                    <template v-if="offerItem.plan.max_payment_choices === 2">
                                        Pay {{ offerItem.payment | money }} in 1 or 2 payments
                                    </template>
                                    <template v-if="offerItem.plan.max_payment_choices > 2">
                                        Pay {{ offerItem.payment | money }} in up to
                                        {{ offerItem.plan.max_payment_choices }} payments
                                    </template>
                                </p>
                                <p v-else :class="`text-base text-${$root.theme}-700 font-semibold leading-snug`">
                                    Schedule a one time payment of {{ offerItem.payment | money }}
                                </p>
                                <p class="text-sm font-medium"
                                   :class="{ [`text-${$root.theme}-500`]: selectedOffer && selectedOffer.name === offerItem.name, 'text-gray-500': selectedOffer && selectedOffer.name !== offerItem.name }">
                                    No penalty for early payoff!
                                </p>
                            </a>
                            <div v-if="offerItem.hasOwnProperty('subtext')"
                                :class="`bg-${$root.theme}-700 border-${$root.theme}-700 text-white faded z-0 relative -top-2 -mb-2 border p-1 pt-3 rounded-b-lg text-center`">
                                <p class="text-xs" v-text="offerItem.subtext" />
                            </div>
                        </template>

                        <template v-else-if="offerItem.type === 'settlement' && offerItem.settlement_allowed">
                            <a @click.prevent="$emit('select', offerItem)"
                                :id="offerItem.name"

                                class="relative z-10 block mt-2 faded border p-4 rounded-lg text-center cursor-pointer"
                                :class="{
                                    'bg-white border-gray-300': ! selectedOffer || selectedOffer.name !== offerItem.name,
                                    [`bg-${$root.theme}-50 border-${$root.theme}-700`]: selectedOffer && selectedOffer.name === offerItem.name
                                }">
                                <p :class="`text-base text-${$root.theme}-700 font-semibold leading-snug`">
                                    <template v-if="! offerItem.plan.hasOwnProperty('max_payment_choices') || ! offerItem.plan.max_payment_choices || offerItem.plan.max_payment_choices === 1">
                                        Schedule a one time payment of {{ offerItem.offer | money }}
                                    </template>
                                    <template v-if="offerItem.plan.max_payment_choices === 2">
                                        Pay {{ offerItem.offer | money }} in 1 or 2 payments
                                    </template>
                                    <template v-if="offerItem.plan.max_payment_choices > 2">
                                        Pay {{ offerItem.offer | money }} in up to {{
                                            offerItem.plan.max_payment_choices
                                        }} payments
                                    </template>
                                </p>
                                <p v-if="offerItem.discount > 0" class="text-sm"
                                   :class="{ [`text-${$root.theme}-500`]: ! selectedOffer || selectedOffer.name === offerItem.name, 'text-gray-500': selectedOffer && selectedOffer.name !== offerItem.name }">
                                    {{ offerItem.discount }}% off, that's a savings of {{ offerItem.savings | money }}!
                                </p>
                                <p v-else class="text-sm"
                                   :class="{ [`text-${$root.theme}-500`]: ! selectedOffer || selectedOffer.name === offerItem.name, 'text-gray-500': selectedOffer && selectedOffer.name !== offerItem.name }">
                                    On total balance of {{ offerItem.full | money }}
                                </p>
                            </a>
                            <div v-if="offerItem.hasOwnProperty('subtext')"
                                 :class="`bg-${$root.theme}-700 border-${$root.theme}-700 text-white faded z-0 relative -top-2 -mb-2 border p-1 pt-3 rounded-b-lg text-center`">
                                <p class="text-xs" v-text="offerItem.subtext" />
                            </div>
                        </template>

                        <a @click.prevent="$emit('select', offerItem)"
                            :id="offerItem.name"
                            v-else-if="offerItem.type === 'settlement-payments'"
                            class="block mt-2 faded border p-4 rounded-lg text-center cursor-pointer"
                            :class="{
                                'bg-white border-gray-300': ! selectedOffer || selectedOffer.name !== offerItem.name,
                                [`bg-${$root.theme}-50 border-${$root.theme}-700`]: selectedOffer && selectedOffer.name === offerItem.name
                            }">
                            <p :class="`text-base text-${$root.theme}-700 font-semibold leading-snug`">
                                <template v-if="offerItem.plan.max_payment_choices === 1">
                                    Pay {{ offerItem.payment | money }}
                                </template>
                                <template v-if="offerItem.plan.max_payment_choices === 2">
                                    Pay {{ offerItem.payment | money }} in 1 or 2 payments
                                </template>
                                <template v-if="offerItem.plan.max_payment_choices > 2">
                                    Pay {{ offerItem.payment | money }} in up to {{
                                        offerItem.plan.max_payment_choices
                                    }} payments
                                </template>
                                <template v-if="!offerItem.plan.max_payment_choices && offerItem.payments">
                                    {{ offerItem.payments }} payments of {{ offerItem.payment | money }}
                                </template>
                            </p>
                            <p v-if="offerItem.discount > 0" class="text-sm"
                               :class="{ [`text-${$root.theme}-500`]: selectedOffer && selectedOffer.name === offerItem.name, 'text-gray-500': selectedOffer && selectedOffer.name !== offerItem.name }">
                                {{ offerItem.discount }}% off, that's a savings of {{ offerItem.savings | money }}!
                            </p>
                            <p v-else class="text-sm"
                               :class="{ [`text-${$root.theme}-500`]: selectedOffer && selectedOffer.name === offerItem.name, 'text-gray-500': selectedOffer && selectedOffer.name !== offerItem.name }">
                                On total balance of {{ account.current_balance | money }}
                            </p>
                        </a>

                        <a @click.prevent="$emit('select', offerItem)"
                            :id="offerItem.name"
                            v-else-if="offerItem.type === 'full-balance'"
                            class="block mt-2 faded border p-4 rounded-lg text-center cursor-pointer"
                            :class="{
                                'bg-white border-gray-300': ! selectedOffer || selectedOffer.name !== offerItem.name,
                                [`bg-${$root.theme}-50 border-${$root.theme}-700`]: selectedOffer && selectedOffer.name === offerItem.name
                            }">
                            <p :class="`text-base text-${$root.theme}-700 font-semibold leading-snug`">
                                Schedule a one time payment of {{ offerItem.payment | money }}
                            </p>
                            <p class="text-sm"
                               :class="{ [`text-${$root.theme}-500`]: selectedOffer && selectedOffer.name === offerItem.name, 'text-gray-500': selectedOffer && selectedOffer.name !== offerItem.name }">
                                On total balance of {{ offerItem.offer | money }}
                            </p>
                        </a>

                        <a @click.prevent="$emit('select', offerItem)"
                            :id="offerItem.name"
                            v-else-if="offerItem.type === 'low-payments'"
                            class="block mt-2 faded border p-4 rounded-lg text-center cursor-pointer"
                           :class="{
                               'bg-white border-gray-300': ! selectedOffer || selectedOffer.name !== offerItem.name,
                               [`bg-${$root.theme}-50 border-${$root.theme}-700`]: selectedOffer && selectedOffer.name === offerItem.name
                           }">
                            <p :class="`text-base text-${$root.theme}-700 font-semibold leading-snug`">
                                <template v-if="offerItem.amount === 100">
                                    Payments of {{ offerItem.amount | money }}
                                </template>
                                <template v-else>
                                    Low payments of {{ offerItem.amount | money }}
                                </template>
                            </p>
                            <p class="text-sm"
                               :class="{ [`text-${$root.theme}-500`]: selectedOffer && selectedOffer.name === offerItem.name, 'text-gray-500': selectedOffer && selectedOffer.name !== offerItem.name }">
                                On total balance of {{ account.current_balance | money }}
                            </p>
                        </a>

                        <a @click.prevent="$emit('select', offerItem)"
                            :id="offerItem.name"
                            v-else-if="offerItem.type === 'low-payments-multi'"
                            class="block mt-2 faded border p-4 rounded-lg text-center cursor-pointer"
                            :class="{
                                'bg-white border-gray-300': ! selectedOffer || selectedOffer.name !== offerItem.name,
                                [`bg-${$root.theme}-50 border-${$root.theme}-700`]: selectedOffer && selectedOffer.name === offerItem.name
                            }">
                            <p :class="`text-base text-${$root.theme}-700 font-semibold leading-snug`">
                                <template>
                                    Payments as low as {{ offerItem.amounts[0] | money }}
                                </template>
                            </p>
                            <p class="text-sm"
                               :class="{ [`text-${$root.theme}-500`]: selectedOffer && selectedOffer.name === offerItem.name, 'text-gray-500': selectedOffer && selectedOffer.name !== offerItem.name }">
                                On total balance of {{ account.current_balance | money }}
                            </p>
                        </a>

                        <a @click.prevent="$emit('select', offerItem)"
                            :id="offerItem.name"
                            v-else-if="offerItem.type === 'low-payments-multi-with-dp'"
                            class="block mt-2 faded border p-4 rounded-lg text-center cursor-pointer"
                            :class="{
                                'bg-white border-gray-300': ! selectedOffer || selectedOffer.name !== offerItem.name,
                                [`bg-${$root.theme}-50 border-${$root.theme}-700`]: selectedOffer && selectedOffer.name === offerItem.name
                            }">
                            <p :class="`text-base text-${$root.theme}-700 font-semibold leading-snug`">
                                Payments as low as {{ offerItem.amounts[0] | money }}
                            </p>
                            <p :class="`text-base text-${$root.theme}-700 font-medium leading-snug`">
                                With down payment of {{ offerItem.down_payment | money }}
                            </p>
                            <p class="text-sm"
                               :class="{ [`text-${$root.theme}-500`]: selectedOffer && selectedOffer.name === offerItem.name, 'text-gray-500': selectedOffer && selectedOffer.name !== offerItem.name }">
                                On total balance of {{ account.current_balance | money }}
                            </p>
                        </a>

                        <a @click.prevent="$emit('select', offerItem)"
                            :id="offerItem.name"
                            v-else-if="offerItem.type === 'custom'"
                            class="block mt-2 faded border p-4 rounded-lg text-center cursor-pointer"
                            :class="{
                                'bg-white border-gray-300': ! selectedOffer || selectedOffer.name !== offerItem.name,
                                [`bg-${$root.theme}-50 border-${$root.theme}-700`]: selectedOffer && selectedOffer.name === offerItem.name
                            }">
                            <p :class="`text-base text-${$root.theme}-700 font-semibold leading-snug`">
                                Enter your own payment amount
                            </p>

                            <p class="text-sm"
                               :class="{ [`text-${$root.theme}-500`]: selectedOffer && selectedOffer.name === offerItem.name, 'text-gray-500': selectedOffer && selectedOffer.name !== offerItem.name }">
                                Flexible payments on the Total Balance of {{ account.current_balance | money }}
                            </p>
                        </a>

                        <a @click.prevent="$emit('select', offerItem)"
                            :id="offerItem.name"
                            v-else-if="offerItem.type === 'custom-or-full'"
                            class="block mt-2 faded border p-4 rounded-lg text-center cursor-pointer"
                            :class="{
                                'bg-white border-gray-300': ! selectedOffer || selectedOffer.name !== offerItem.name,
                                [`bg-${$root.theme}-50 border-${$root.theme}-700`]: selectedOffer && selectedOffer.name === offerItem.name
                            }">
                            <p :class="`text-base text-${$root.theme}-700 font-semibold leading-snug`">
                                Enter your own payment amount
                            </p>
                            <p class="text-sm"
                               :class="{ [`text-${$root.theme}-500`]: selectedOffer && selectedOffer.name === offerItem.name, 'text-gray-500': selectedOffer && selectedOffer.name !== offerItem.name }">
                                Flexible payments on the Total Balance of {{ account.current_balance | money }}
                            </p>
                        </a>

                        <a :href="`${$parent.data.consumerPortalBaseUrl}/account`"
                            v-else-if="offerItem.type === 'early-no-thanks'"
                            class="block mt-2 faded border p-4 rounded-lg text-center cursor-pointer"
                            :class="{
                                'bg-white border-gray-300': ! selectedOffer || selectedOffer.name !== offerItem.name,
                                [`bg-${$root.theme}-50 border-${$root.theme}-700`]: selectedOffer && selectedOffer.name === offerItem.name
                            }">
                            <p :class="`text-base text-${$root.theme}-700 font-semibold leading-snug`">
                                No thank you
                            </p>
                            <p class="text-sm"
                               :class="{ [`text-${$root.theme}-500`]: selectedOffer && selectedOffer.name === offerItem.name, 'text-gray-500': selectedOffer && selectedOffer.name !== offerItem.name }">
                                Continue to account summary
                            </p>
                        </a>
                    </template>

                </template>
            </div>
        </div>
        <form v-if="selectedOffer" method="POST" @submit.prevent="ccValidStatus ? acceptOffer() : false">

            <div v-if="selectedOffer.type === 'custom-or-full'" class="border-b border-t border-gray-200">
                <div class="p-5 mx-auto md:w-2/3 lg:w-1/2 xl:w-1/3 2xl:w-1/4">
                    <span class="relative z-0 inline-flex shadow-sm rounded-md w-full">
                        <button type="button"
                                class="relative inline-flex flex-1 items-center justify-center px-4 pb-1 pt-2 rounded-l-md border text-sm focus:z-10 focus:outline-none focus:ring-1"
                                @click="payment.payment_type = 'custom'"
                                :class="{
                                [`border-gray-300 bg-white text-gray-700 hover:bg-gray-50 focus:ring-${$root.theme}-500 focus:border-${$root.theme}-500 font-semibold`]: payment.payment_type && payment.payment_type !== 'custom',
                                [`bg-${$root.theme}-300 hover:bg-${$root.theme}-400 text-black focus:ring-${$root.theme}-200 border-${$root.theme}-300 focus:border-${$root.theme}-500 font-semibold`]: !payment.payment_type || payment.payment_type !== 'full',
                            }">
                            Custom Payment Amount
                        </button>
                        <button type="button"
                                class="relative inline-flex flex-1 items-center justify-center px-4 pb-1 pt-2 rounded-r-md border text-sm focus:z-10 focus:outline-none focus:ring-1"
                                @click="payment.payment_type = 'full'"
                                :class="{
                            [`border-gray-300 bg-white text-gray-700 hover:bg-gray-50 focus:ring-${$root.theme}-500 focus:border-${$root.theme}-500 font-semibold`]: payment.payment_type !== 'full',
                            [`bg-${$root.theme}-300 hover:bg-${$root.theme}-400 text-black focus:ring-${$root.theme}-200 border-${$root.theme}-300 focus:border-${$root.theme}-500 font-semibold`]: payment.payment_type === 'full',
                        }">
                            Full Balance of {{ account.current_balance | money }}
                        </button>
                    </span>
                </div>
            </div>

            <div v-if="selectedOffer.amounts && selectedOffer.amounts.length" class="border-b border-t border-gray-200">
                <div class="p-5 mx-auto md:w-2/3 lg:w-1/2 xl:w-1/3 2xl:w-1/4">
                    <span class="relative z-0 inline-flex shadow-sm rounded-md w-full">
                        <button type="button"
                                class="relative inline-flex flex-1 items-center justify-center px-4 pb-1 pt-2 rounded-l-md border text-sm focus:z-10 focus:outline-none focus:ring-1"
                                @click="payment.amount = selectedOffer.amounts[0]"
                                :class="{
                                    [`border-gray-300 bg-white text-gray-700 hover:bg-gray-50 focus:ring-${$root.theme}-500 focus:border-${$root.theme}-500 font-semibold`]: payment.amount && payment.amount !== selectedOffer.amounts[0],
                                    [`bg-${$root.theme}-300 hover:bg-${$root.theme}-400 text-black focus:ring-${$root.theme}-200 border-${$root.theme}-300 focus:border-${$root.theme}-500 font-semibold`]: !payment.amount || payment.amount === selectedOffer.amounts[0],
                                }">
                            {{ selectedOffer.amounts[0] | money }}
                        </button>
                        <button type="button"
                                class="relative inline-flex flex-1 items-center justify-center px-4 pb-1 pt-2 rounded-r-md border text-sm focus:z-10 focus:outline-none focus:ring-1"
                                @click="payment.amount = selectedOffer.amounts[1]"
                                :class="{
                                    [`border-gray-300 bg-white text-gray-700 hover:bg-gray-50 focus:ring-${$root.theme}-500 focus:border-${$root.theme}-500 font-semibold`]: payment.amount !== selectedOffer.amounts[0],
                                    [`bg-${$root.theme}-300 hover:bg-${$root.theme}-400 text-black focus:ring-${$root.theme}-200 border-${$root.theme}-300 focus:border-${$root.theme}-500 font-semibold`]: payment.amount === selectedOffer.amounts[1],
                                }">
                            {{ selectedOffer.amounts[1] | money }}
                        </button>
                    </span>
                </div>
            </div>
            <div v-if="showFrequency" class="border-b border-t border-gray-200">
                <div class="p-5 mx-auto md:w-2/3 lg:w-1/2 xl:w-1/3 2xl:w-1/4">
                    <span class="relative z-0 inline-flex shadow-sm rounded-md w-full"
                          :class="{ 'mb-4': selectedOffer.type === 'custom' }">
                        <button type="button"
                                class="relative inline-flex flex-1 items-center justify-center px-4 pb-1 pt-2 rounded-l-md border text-sm focus:z-10 focus:outline-none focus:ring-1"
                                @click="payment.frequency = 'monthly'"
                                :class="{
                                [`border-gray-300 bg-white text-gray-700 hover:bg-gray-50 focus:ring-${$root.theme}-500 focus:border-${$root.theme}-500 font-semibold`]: payment.frequency !== 'monthly',
                                [`bg-${$root.theme}-300 hover:bg-${$root.theme}-400 text-black focus:ring-${$root.theme}-200 border-${$root.theme}-300 focus:border-${$root.theme}-500 font-semibold`]: payment.frequency === 'monthly',
                            }">
                            Monthly
                        </button>
                        <button type="button"
                                class="relative inline-flex flex-1 items-center justify-center px-4 pb-1 pt-2 rounded-r-md border text-sm focus:z-10 focus:outline-none focus:ring-1"
                                @click="payment.frequency = 'biweekly'"
                                :class="{
                                [`border-gray-300 bg-white text-gray-700 hover:bg-gray-50 focus:ring-${$root.theme}-500 focus:border-${$root.theme}-500 font-semibold`]: payment.frequency !== 'biweekly',
                                [`bg-${$root.theme}-300 hover:bg-${$root.theme}-400 text-black focus:ring-${$root.theme}-200 border-${$root.theme}-300 focus:border-${$root.theme}-500 font-semibold`]: payment.frequency === 'biweekly',
                            }">
                            Every 2 Weeks
                        </button>
                    </span>

                    <label v-if="selectedOffer.type === 'custom'" for="amount">Enter desired recurring payment amount
                        below:</label>
                    <p v-if="error && error.hasOwnProperty('amount')"
                       class="mt-2 mb-3 text-sm text-red-600 bg-red-50 border-red-600 rounded-lg p-3"
                       style="border-width: 1px;" id="email-error">
                        {{ error.amount[0] }}
                    </p>
                    <div v-if="selectedOffer.type === 'custom'" class="mt-1 flex rounded-md shadow-sm">
                        <span class="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm">
                            $
                        </span>
                        <input v-model="payment.amount"
                               type="text"
                               name="amount"
                               id="amount"
                               :class="`bg-gray-50 focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 block w-full py-3 pl-4 pr-4 sm:text-sm border-gray-300 rounded-t rounded-r rounded-b`"
                               placeholder="Payment Amount">
                    </div>
                </div>
            </div>

            <div v-if="!showFrequency && selectedOffer.frequency" class="border-b border-t border-gray-200">
                <div class="p-5 mx-auto md:w-2/3 lg:w-1/2 xl:w-1/3 2xl:w-1/4">
                    <span class="relative z-0 inline-flex shadow-sm rounded-md w-full">
                        <button
                            v-if="selectedOffer.frequency === 'monthly'"
                            type="button"
                            :class="`relative inline-flex flex-1 items-center justify-center px-4 pb-1 pt-2 rounded-l-md border text-sm focus:z-10 focus:outline-none focus:ring-1 bg-${$root.theme}-300 hover:bg-${$root.theme}-400 text-black focus:ring-${$root.theme}-200 border-${$root.theme}-300 focus:border-${$root.theme}-500 font-semibold`">
                            Monthly
                        </button>
                        <button
                            v-if="selectedOffer.frequency === 'biweekly'"
                            type="button"
                            :class="`relative inline-flex flex-1 items-center justify-center px-4 pb-1 pt-2 rounded-r-md border text-sm focus:z-10 focus:outline-none focus:ring-1 bg-${$root.theme}-300 hover:bg-${$root.theme}-400 text-black focus:ring-${$root.theme}-200 border-${$root.theme}-300 focus:border-${$root.theme}-500 font-semibold`">
                            Every 2 Weeks
                        </button>
                        <button
                            v-if="selectedOffer.frequency === 'onetime'"
                            type="button"
                            :class="`relative inline-flex flex-1 items-center justify-center px-4 pb-1 pt-2 rounded-r-md border text-sm focus:z-10 focus:outline-none focus:ring-1 bg-${$root.theme}-300 hover:bg-${$root.theme}-400 text-black focus:ring-${$root.theme}-200 border-${$root.theme}-300 focus:border-${$root.theme}-500 font-semibold`">
                            One Time
                        </button>
                    </span>
                </div>
            </div>


            <div
                v-if="selectedOffer.plan && selectedOffer.plan.max_payment_choices && selectedOffer.plan.max_payment_choices > 1"
                class="border-b border-t border-gray-200">
                <div class="p-5 mx-auto md:w-2/3 lg:w-1/2 xl:w-1/3 2xl:w-1/4">
                    <template v-if="selectedOffer.plan.max_payment_choices < 3">
                        <span class="relative z-0 inline-flex shadow-sm rounded-md w-full">
                            <button type="button"
                                    class="relative inline-flex flex-1 items-center justify-center px-4 pb-1 pt-2 rounded-l-md border text-sm focus:z-10 focus:outline-none focus:ring-1"
                                    @click="payment.payment_count = 1"
                                    :class="{
                                    [`border-gray-300 bg-white text-gray-700 hover:bg-gray-50 focus:ring-${$root.theme}-500 focus:border-${$root.theme}-500 font-semibold`]: payment.payment_count !== 1,
                                    [`bg-${$root.theme}-300 hover:bg-${$root.theme}-400 text-black focus:ring-${$root.theme}-200 border-${$root.theme}-300 focus:border-${$root.theme}-500 font-semibold`]: payment.payment_count === 1,
                                }">
                                One Payment
                            </button>
                            <button type="button"
                                    class="relative inline-flex flex-1 items-center justify-center px-4 pb-1 pt-2 rounded-r-md border text-sm focus:z-10 focus:outline-none focus:ring-1"
                                    @click="payment.payment_count = 2"
                                    :class="{
                                    [`border-gray-300 bg-white text-gray-700 hover:bg-gray-50 focus:ring-${$root.theme}-500 focus:border-${$root.theme}-500 font-semibold`]: payment.payment_count !== 2,
                                    [`bg-${$root.theme}-300 hover:bg-${$root.theme}-400 text-black focus:ring-${$root.theme}-200 border-${$root.theme}-300 focus:border-${$root.theme}-500 font-semibold`]: payment.payment_count === 2,
                                }">
                                Two Payments
                            </button>
                        </span>
                    </template>

                    <template v-else-if="selectedOffer.plan.max_payment_choices > 2">
                        How many payments would you like to make?

                        <select
                            v-model="payment.payment_count"
                            id="payment-count"
                            :class="`bg-gray-50 focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 mt-1 block w-full pl-4 pr-10 py-3 text-base border-gray-300 focus:outline-none sm:text-sm rounded-md`">
                            <option v-for="paymentCount in paymentCountGenerator(
                                    selectedOffer.plan.min_payment_choices,
                                    selectedOffer.plan.max_payment_choices
                                )"
                                v-bind:value="paymentCount">
                                <template v-if="paymentCount > 1 && selectedOffer.hasOwnProperty('down_payment')">
                                    1 Payment of {{ selectedOffer.down_payment | money }} -
                                    {{ paymentCount }} Payment{{ paymentCount > 1 ? 's' : '' }} of
                                    {{ paymentAmountFromCount(paymentCount) | money }}
                                    <template v-if="paymentCount > 1">
                                        each
                                        <template v-if="firstPaymentOffer">
                                            ({{ pdoString(paymentCount) }})
                                        </template>
                                    </template>
                                </template>
                                <template v-else>
                                    {{ paymentCount }} Payment{{ paymentCount > 1 ? 's' : '' }} -
                                    {{ paymentAmountFromCount(paymentCount) | money }}
                                    <template v-if="paymentCount > 1">
                                        each
                                        <template v-if="firstPaymentOffer">
                                            ({{ pdoString(paymentCount) }})
                                        </template>
                                    </template>
                                </template>
                            </option>
                        </select>
                    </template>


                </div>
            </div>
            <div class="border-b border-gray-300">
                <div class="p-5 mx-auto md:w-2/3 lg:w-1/2 xl:w-1/3 2xl:w-1/4">
                    <p v-if="payment.payment_count === 1 || ! selectedOffer.hasOwnProperty('down_payment')" class="font-medium text-sm text-justify">
                        Your payment of <strong>{{ paymentAmount | money }}</strong> will be charged immediately
                        <strong>or</strong> choose a future date you wish to make the payment on.
                    </p>
                    <p v-else-if="selectedOffer.hasOwnProperty('down_payment')" class="font-medium text-sm text-justify">
                        Your down payment of <strong>{{ selectedOffer.down_payment | money }}</strong> will be charged immediately
                        <strong>or</strong> choose a future date you wish to make the payment on.
                    </p>

                    <p class="text-right text-xs font-medium text-gray-500 p-1">Click on the calendar below to select a date.</p>
                    <input v-model="payment.payment_dates[0]"
                           :min="minPaymentDate || today"
                           :max="account.last_payment_date"
                           :disabled="selectedOffer.date != null"
                           type="date"
                           name="date_0"
                           id="date_0"
                           :class="`bg-gray-50 focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 block w-full py-3 pl-4 pr-4 sm:text-sm border-gray-300 rounded-md`"
                           @input="validateDate(0)"
                           placeholder="Payment Date">

                    <p v-if="invalidDates.indexOf(0) !== -1" class="mt-3 text-sm text-red-600" v-text="invalidDateText(0)" />

                    <template v-if="showFrequency || (payment && payment.payment_count > 1)">
                        <p v-if="selectedOffer &&
                            (
                                selectedOffer.type === 'full-settlement-with-dp'
                                || selectedOffer.type === 'low-payments-multi-with-dp'
                            )" class="font-medium text-sm text-justify mb-2 mt-4">
                            Your down payment of <strong>{{ selectedOffer.down_payment | money }}</strong> will be <strong>{{ paymentDue(0) }}.</strong>
                        </p>
                        <p v-else-if="selectedOffer" class="font-medium text-sm text-justify mb-2 mt-4">
                            Your initial payment will be <strong>{{ paymentDue(0) }}.</strong>
                        </p>
                    </template>
                </div>
            </div>

            <div class="border-b border-gray-300">
                <div class="p-5 mx-auto md:w-2/3 lg:w-1/2 xl:w-1/3 2xl:w-1/4">
                    <template v-if="showFrequency || (payment && payment.payment_count > 1)">
                        <p class="font-medium text-sm text-justify">
                            And then the following payment of <strong>{{ paymentAmount | money }}</strong> will be charged
                            <template v-if="payment && payment.frequency === 'monthly'">
                                <template v-if="paymentDateIsLastDayOfMonth(1)">
                                    the last day of
                                </template>
                                the following month
                            </template>
                            <template v-else-if="payment && payment.frequency === 'biweekly'">
                                two weeks later
                            </template>
                            <strong>or</strong> choose a future date you wish to begin {{ payment.frequency }} payments.
                        </p>

                        <p class="text-right text-xs font-medium text-gray-500 p-1">Click on the calendar below to select a date.</p>
                        <input v-model="payment.payment_dates[1]"
                               :min="paymentDateDayAfter(0).format('YYYY-MM-DD')"
                               :max="nextFrequencyFromPaymentDate(payment.payment_dates[0]).format('YYYY-MM-DD')"
                               :disabled="selectedOffer.date != null"
                               type="date"
                               name="date_1"
                               id="date_1"
                               :class="`bg-gray-50 focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 block w-full py-3 pl-4 pr-4 sm:text-sm border-gray-300 rounded-md`"
                               @input="validateDate(1)"
                               placeholder="Second Payment Date">

                        <p v-if="invalidDates.indexOf(1) !== -1" id="invalid-date-1" class="mt-3 text-sm text-red-600" v-text="invalidDateText(1)" />
                    </template>

                    <p v-if="selectedOffer
                        && payment.frequency === 'monthly'
                        && ! paymentDateIsLastDayOfMonth(1)"
                       class="font-medium text-sm text-justify mb-2" :class="{'mt-4': showFrequency || (payment && payment.payment_count > 1)}">
                        <template v-if="payment && payment.payment_count !== 1">
                            Your following payment will be <strong>{{ paymentDue(1) }}.</strong>
                            And any possible subsequent payments will be automatically set for the <strong>{{ getNextMonth(payment.payment_dates[1]).format('Do') }}</strong> of each month moving forward.
                        </template>
                        <template v-else>
                            Your payment will be <strong>{{ paymentDue(0) }}.</strong>
                        </template>
                        Please be advised that if the <strong>{{ payment && payment.payment_count !== 1 ? getNextMonth(payment.payment_dates[1]).format('Do') : getNextMonth(payment.payment_dates[0]).format('Do') }}</strong> falls on a weekend or bank holiday the payment may fall on the next business day.
                        <span v-if="payment && payment.payment_count !== 1" class="block pt-2">To split your payments as evenly as possible, the amount of your last payment may vary slightly from the amount selected above. Unless you notify us with your specific request, we will not provide further notice when the amount of a debit entry will be lower than the amount you authorized.</span>
                    </p>
                    <p v-else-if="selectedOffer
                        && payment.frequency === 'monthly'
                        && paymentDateIsLastDayOfMonth(1)"
                       class="font-medium text-sm text-justify mb-2" :class="{'mt-4': showFrequency || (payment && payment.payment_count > 1)}">
                        <template v-if="payment && payment.payment_count !== 1">
                            Your following payment will be <strong>{{ paymentDue(1) }}.</strong>
                            And any possible subsequent payments will be automatically set for the <strong>last day</strong> of each month moving forward.
                        </template>
                        <template v-else>
                            Your payment will be <strong>{{ paymentDue(0) }}.</strong>
                        </template>
                        Please be advised that if the <strong>last day</strong> of each month falls on a weekend or bank holiday the payment may fall on the next business day.
                        <span v-if="payment && payment.payment_count !== 1" class="block pt-2">To split your payments as evenly as possible, the amount of your last payment may vary slightly from the amount selected above. Unless you notify us with your specific request, we will not provide further notice when the amount of a debit entry will be lower than the amount you authorized.</span>
                    </p>
                    <p v-else-if="selectedOffer
                        && payment.frequency === 'biweekly'"
                       class="font-medium text-sm text-justify mb-2" :class="{'mt-4': showFrequency || (payment && payment.payment_count > 1)}">
                        <template v-if="payment && payment.payment_count !== 1">
                            Your following payment will be <strong>{{ paymentDue(1) }}.</strong>
                            And any possible subsequent payments will be automatically set for <strong>every two weeks</strong> moving forward.
                        </template>
                        <template v-else>
                            Your payment will be <strong>{{ paymentDue(0) }}.</strong>
                        </template>
                        Please be advised that if the payment date falls on a weekend or bank holiday the payment may fall on the next business day.
                        <span v-if="payment && payment.payment_count !== 1" class="block pt-2">To split your payments as evenly as possible, the amount of your last payment may vary slightly from the amount selected above. Unless you notify us with your specific request, we will not provide further notice when the amount of a debit entry will be lower than the amount you authorized.</span>
                    </p>

                    <p class="font-medium text-sm text-justify">
                        Should you have any questions or require additional assistance please do not hesitate to give us
                        a call at <a :href="`tel:${$root.phoneNumberForLocation('payment-setup-date-selection')}`" style="white-space: nowrap;">{{ $root.phoneNumberForLocation('payment-setup-date-selection') }}</a>.
                    </p>
                </div>
            </div>
            <div class="border-b border-gray-300">
                <div class="p-5 mx-auto md:w-2/3 lg:w-1/2 xl:w-1/3 2xl:w-1/4">
                    <div class="block font-semibold text-gray-700 mb-2">
                        <svg class="inline w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"/>
                        </svg>
                        Select a Payment Method:
                    </div>

                    <select v-if="settings.enable_ach || billingProfile"
                            v-model="payment.type"
                            @change="$emit('clear-error')"
                            id="payment_method"
                            name="payment_method"
                            :class="`bg-gray-50 focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 mt-1 block w-full pl-4 pr-10 py-3 text-base border-gray-300 focus:outline-none sm:text-sm rounded-md`">
                        <option :value="null">Choose Method:</option>
                        <option value="same" v-if="billingProfile && billingProfile.payment_type">
                            {{ billingProfile.payment_type === 'check' ? 'Checking' : billingProfile.card_type }} •••• {{ billingProfile.account_last_4 ?? billingProfile.account_last_four }}
                        </option>
                        <option v-if="settings.enable_ach" value="check">Pay with Personal Bank account</option>
                        <option value="card">Pay with Credit/Debit Card</option>
                    </select>

                    <pay-with-bank v-if="settings.enable_ach && payment.type === 'check'"
                                   :first_name.sync="payment.first_name"
                                   :last_name.sync="payment.last_name"
                                   :address.sync="payment.address"
                                   :city.sync="payment.city"
                                   :state.sync="payment.state"
                                   :routing_number.sync="payment.routing_number"
                                   :account_number.sync="payment.account_number"
                                   :error="error" class="mt-4"
                                   :states="states"
                                   :settings="settings"/>

                    <pay-with-card v-else-if="payment.type === 'card'"
                                   :first_name.sync="payment.first_name"
                                   :last_name.sync="payment.last_name"
                                   :address.sync="payment.address"
                                   :city.sync="payment.city"
                                   :state.sync="payment.state"
                                   :cc_number.sync="payment.cc_number"
                                   :card_exp.sync="payment.card_exp"
                                   :cvv.sync="payment.cvv"
                                   :zip.sync="payment.zip"
                                   :error="error" class="mt-4"
                                   :states="states"
                                   :settings="settings"
                                   :cc-valid-status="ccValidStatus"/>
                </div>
            </div>
            <div>
                <div class="p-5 mx-auto md:w-2/3 lg:w-1/2 xl:w-1/3 2xl:w-1/4">
                    <p v-if="false" class="text-sm text-gray-500 mb-2">
                        By clicking "Continue" you are confirming that you are the owner and/or authorized user of the
                        method of payment provided and you are hereby authorizing {{ $parent.data.consumerPortalName }} to
                        process payment(s) using this information.
                    </p>


                    <p class="text-sm mb-2" v-if="paymentFee
                        && selectedOffer
                        && (
                            selectedOffer.type === 'low-payments-multi-with-dp'
                            || selectedOffer.type === 'full-settlement-with-dp'
                        )"
                        v-show="showFeeMessage">
                        Your payment will be {{ (payment.payment_count === 1
                            ? (selectedOffer.down_payment + paymentFee)
                            : getPaymentAmount(selectedOffer.down_payment) + paymentFee) | money }}
                        which includes a fee of {{ paymentFee | money }}.
                    </p>
                    <p class="text-sm mb-2" v-else-if="paymentFee" v-show="showFeeMessage">
                        Your payment will be {{ (payment.payment_count === 1
                            ? (paymentAmount + paymentFee)
                            : getPaymentAmount(paymentAmount) + paymentFee) | money }}
                        which includes a fee of {{ paymentFee | money }}.
                    </p>

                    <p v-if="error" class="mb-3 text-sm text-red-600 bg-red-50 border-red-600 rounded-lg p-3"
                       style="border-width: 1px;" id="email-error">
                        <span v-if="typeof error === 'string'" v-html="`ERROR: ${error}<br />`"/>
                        There was a problem processing your payment. Please check your information and try again or
                        contact our support team at {{ $parent.data.consumerPortalName }} by phone at
                        <a :href="`tel:${$root.phoneNumberForLocation('payment-setup-decline')}`" style="text-decoration: underline;">{{ $root.phoneNumberForLocation('payment-setup-decline') }}</a>
                        or by email at <a :href="`mailto:${$parent.data.consumerPortalEmail}`" style="text-decoration: underline;">{{ $parent.data.consumerPortalEmail }}</a>
                        to complete your transaction.
                    </p>

                    <button type="submit" id="available-offers-continue-button"
                        :class="[
                            `w-full justify-center text-black items-center inline-flex items-center px-3 text-lg pt-4 pb-3 border border-transparent shadow-sm leading-4 font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 bg-${$root.theme}-300 hover:bg-${$root.theme}-400 focus:ring-${$root.theme}-200`,
                            ! ccValidStatus ? `cursor-not-allowed opacity-50` : null,
                        ]">
                        <svg class="-ml-0.5 mr-3 h-4 w-4 mb-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clip-rule="evenodd"/>
                        </svg>
                        Continue
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import Moment from 'moment';
import PayWithCard from './PaymentMethods/PayWithCard';
import PayWithBank from './PaymentMethods/PayWithBank';
import ElectronicConsentModal from "./Modals/ElectronicConsentModal.vue";

export default {
    components: {
        ElectronicConsentModal,
        PayWithBank,
        PayWithCard
    },

    props: {
        mostPopularSubtext: {
            type: String,
            default: 'Most Popular'
        },
        pdoConfig: {
            type: Object,
            default: () => {
            }
        },
        firstPaymentOffer: {
            type: Boolean,
            default: false
        },
        special: {
            type: Boolean,
            default: false
        },
        error: {
            required: true
        },
        offer: {
            type: Object,
            default: () => null
        },
        offers: {
            type: Array,
            default: () => []
        },
        account: {
            type: Object,
            required: true
        },
        settings: {
            type: Object,
            required: true
        },
        selectedOffer: {
            type: Object,
            default: () => null
        },
        billingProfile: {
            type: Object,
            default: () => null
        },
        states: {
            type: Object,
            default: () => null
        },
        minPaymentDate: {
            type: String,
            default: null
        }
    },

    /**
     * Auto set today as payment_date and if ACH is disabled
     * in settings, then change method to card.
     *
     * @returns {void}
     */
    mounted() {
        if (this.minPaymentDate) {
            this.payment.payment_dates[0] = this.minPaymentDate;

            this.setDefaultDate(1);
        } else {
            this.payment.payment_dates[0] = Moment().format('YYYY-MM-DD');

            this.setDefaultDate(1);
        }

        if (!this.settings.enable_ach && !this.billingProfile) {
            this.payment.type = 'card';
        } else if (this.billingProfile) {
            this.payment.type = 'same';
            this.payment.billing_profile_id = this.billingProfile.id;
        }

        if ((this.offers && this.offers.length) || this.offer) {
            this.setupSortedOffers();
        }
    },

    data() {
        return {
            sortedOffers: [],
            firstTimeShowingFee: false,
            showingElectronicConsentModal: false,
            payment: {
                type: 'card',
                amount: null,
                payment_type: 'custom',
                payment_date: '',
                payment_date_second: '',
                payment_dates: [],
                frequency: 'monthly',
                first_name: '',
                last_name: '',
                address: '',
                city: '',
                state: '',
                billing_profile_id: null,

                routing_number: '',
                account_number: '',

                cc_number: '',
                card_exp: '',
                exp_month: '',
                exp_year: '',
                cvv: '',
                zip: '',
                payment_count: 1
            },
            invalidDates: []
        }
    },

    computed: {
        today() {
            return Moment().format('YYYY-MM-DD');
        },

        ccValidStatus() {
            if (/[^0-9-\s]+/.test(this.payment.cc_number)) return false;

            // The Luhn Algorithm. It's so pretty.
            var nCheck = 0,
                nDigit = 0,
                bEven = false;

            let value = this.payment.cc_number.replace(/\D/g, "");

            for (var n = value.length - 1; n >= 0; n--) {
                var cDigit = value.charAt(n),
                    nDigit = parseInt(cDigit, 10);

                if (bEven) {
                    if ((nDigit *= 2) > 9) nDigit -= 9;
                }

                nCheck += nDigit;
                bEven = !bEven;
            }

            return (nCheck % 10) == 0;
        },

        readyToSubmit() {
            if (this.payment.first_name === '') return false;
            if (this.payment.last_name === '') return false;
            if (!this.payment.type) return false;

            if (this.payment.type === 'check') {
                if (this.payment.routing_number === '') return false;
                if (this.payment.account_number === '') return false;
            } else if (this.payment.type === 'card') {
                if (this.payment.cc_number === '') return false;
                if (this.payment.card_exp === '') return false;
                if (this.payment.cvv === '') return false;
            }

            return true;
        },

        paymentAmount() {
            if (this.selectedOffer.type === 'custom') {
                if (this.payment.payment_type === 'full') {
                    return parseFloat(this.account.current_balance);
                }

                return parseFloat(this.payment.amount);
            }

            if (typeof this.selectedOffer.amounts !== 'undefined' && this.selectedOffer.amounts.length) {
                return parseFloat(this.payment.amount ? this.payment.amount : this.selectedOffer.amounts[0]);
            }

            let amount = this.selectedOffer.offer
                || this.selectedOffer.amount
                || this.selectedOffer.payment;

            if (this.payment.payment_count === 1) {
                if (this.selectedOffer.type === 'custom') {
                    return parseFloat(this.payment.amount);
                }

                return parseFloat(amount);
            }

            if (this.selectedOffer && this.payment.payment_count) {
                if (this.selectedOffer.custom && this.selectedOffer.payment) {
                    return parseFloat(this.selectedOffer.payment);
                }

                let amount = this.selectedOffer.offer;

                if (this.selectedOffer.hasOwnProperty('down_payment')) {
                    amount -= this.selectedOffer.down_payment;
                }

                return Math.round((amount / this.payment.payment_count) * 100) / 100;
            }
        },

        showFrequency() {
            //if (!this.offer) return true;

            if (this.selectedOffer.type.startsWith('full') || this.selectedOffer.hasOwnProperty('full')) return false;

            // Do not show frequency if they have full balance selected under custom
            if (this.selectedOffer.type === 'custom' && this.payment.payment_type !== 'custom') return false;

            if (this.selectedOffer.frequency) return false;

            return true;
        },

        paymentFee() {
            return parseFloat(this.payment.type === 'card' ? this.account.fees.default_cc_fee : this.account.fees.default_check_fee);
        },

        showFeeMessage() {
            let shouldShowFee = this.shouldShowFee();

            if (shouldShowFee && !this.firstTimeShowingFee) {
                this.firstTimeShowingFee = true;

                this.$parent.gtagEvent('fee-shown-on-offers');

                this.$http.post(`${this.$parent.data.consumerPortalBaseUrl}/api/tracking`, {
                    event: 'last-action',
                    value: 'fee-shown-on-offers'
                }).then(r => {

                }, e => {

                });
            }

            return Boolean(shouldShowFee);
        }
    },

    watch: {
        'payment.frequency'() {
            this.setDefaultDate(1);
        },

        'offers'(offers, oldOffers) {
            if (offers) {
                this.setupSortedOffers();
            }
        },

        /**
         * When changing payment types, clear out opposite type's values.
         *
         * @param paymentType
         * @param oldPaymentType
         * @returns void
         */
        'payment.type'(paymentType, oldPaymentType) {
            switch (paymentType) {
                case 'card':
                    this.payment.routing_number = '';
                    this.payment.account_number = '';

                    break;
                case 'check':
                    this.payment.cc_number = '';
                    this.payment.card_exp = '';
                    this.payment.exp_month = '';
                    this.payment.exp_year = '';
                    this.payment.cvv = '';
                    this.payment.zip = '';
                    break;
            }
        },

            selectedOffer(selectedOffer, oldSelectedOffer) {
            if (this.offer && (selectedOffer && !oldSelectedOffer)) {
                return;
            }

            if (selectedOffer) {
                let offerIndex = this.sortedOffers.findIndex(offer => offer.name === selectedOffer.name);
                let pluckedOffer = this.sortedOffers[offerIndex];

                if (selectedOffer.date) {
                    this.payment.payment_dates[0] = selectedOffer.date;
                }

                if (selectedOffer.second_date) {
                    this.payment.payment_dates[1] = selectedOffer.second_date;
                }

                if (selectedOffer.frequency) {
                    this.payment.frequency = selectedOffer.frequency;
                } else {
                    this.payment.frequency = 'monthly';
                }

                this.$nextTick(() => {
                    this.sortedOffers.splice(offerIndex, 1);
                    this.sortedOffers.push(pluckedOffer);

                    this.$nextTick(() => {
                        let offerElement = document.getElementById(selectedOffer.name);

                        if (offerElement) {
                            window.scrollTo({
                                top: offerElement.offsetTop - 20,
                                behavior: 'smooth'
                            });
                        }

                        if (selectedOffer.plan && selectedOffer.plan.set_payments_number) {
                            this.payment.payment_count = selectedOffer.plan.set_payments_number;
                        } else if (selectedOffer.plan && selectedOffer.plan.min_payment_choices) {
                            this.payment.payment_count = selectedOffer.plan.min_payment_choices;
                        } else {
                            this.payment.payment_count = selectedOffer.payments;
                        }

                        if (typeof selectedOffer.amounts !== 'undefined' && selectedOffer.amounts.length) {
                            this.payment.amount = selectedOffer.amounts[0];
                        }
                    });
                });
            }
        },
    },

    methods: {
        setDefaultDate(dateIdx) {
            this.$nextTick(() => {
                this.payment.payment_dates[dateIdx] = this.payment.frequency === 'monthly'
                    ? this.getNextMonth(this.payment.payment_dates[dateIdx - 1]).format('YYYY-MM-DD')
                    : this.getTwoWeeksLater(this.payment.payment_dates[dateIdx - 1]).format('YYYY-MM-DD');

                this.$forceUpdate();
            });
        },

        validateDate(dateIdx) {
            if (dateIdx === 0) {
                if (
                    this.payment.payment_dates[dateIdx] < this.today
                    || this.payment.payment_dates[dateIdx] > this.account.last_payment_date
                ) {
                    this.invalidDates.push(dateIdx);
                } else {
                    if (this.invalidDates.indexOf(dateIdx) > -1) {
                        this.invalidDates.splice(this.invalidDates.indexOf(dateIdx));
                    }
                }

                this.setDefaultDate(dateIdx + 1);
            } else {
                let previousDateIdx = dateIdx - 1,
                    nextPaymentDate = this.nextFrequencyFromPaymentDate(this.payment.payment_dates[previousDateIdx]);

                if (
                    this.payment.payment_dates[dateIdx] <= this.payment.payment_dates[previousDateIdx]
                    || this.payment.payment_dates[dateIdx] > nextPaymentDate.format('YYYY-MM-DD')
                ) {
                    this.invalidDates.push(dateIdx);
                } else {
                    if (this.invalidDates.indexOf(dateIdx) > -1) {
                        this.invalidDates.splice(this.invalidDates.indexOf(dateIdx));
                    }
                }
            }
        },

        invalidDateText(dateIdx) {
            if (dateIdx === 0) {
                return `Please select a date between today and ${Moment(this.account.last_payment_date).format('MMMM Do')}.`;
            }

            return `Please select a date between ${Moment(this.payment.payment_dates[dateIdx - 1]).add(1, 'day').format('MMMM Do')} and ${this.nextFrequencyFromPaymentDate(this.payment.payment_dates[dateIdx - 1]).format('MMMM Do')}.`;
        },

        paymentDue(dateIdx) {
            if (this.today === this.payment.payment_dates[dateIdx]) return 'due today';

            return Moment(this.payment.payment_dates[dateIdx]).format('MM/DD/YYYY');
        },

        getNextMonth(paymentDate) {
            return Moment(paymentDate).add(1, 'months');
        },

        getTwoWeeksLater(paymentDate) {
            return Moment(paymentDate).add(2, 'weeks');
        },

        nextFrequencyFromPaymentDate(paymentDate) {
            return this.getNextMonth(paymentDate);
            // Requested by Eric/Jon, bi-weekly plans get up to a month as well...
            // return this.payment.frequency === 'monthly'
            //     ? this.getNextMonth(paymentDate)
            //     : this.getTwoWeeksLater(paymentDate);
        },

        paymentDateDayAfter(dateIdx) {
            return Moment(this.payment.payment_dates[dateIdx]).add(1, 'day');
        },

        paymentDateIsLastDayOfMonth(dateIdx) {
            return Moment(this.payment.payment_dates[dateIdx]).format('DD')
                === Moment(this.payment.payment_dates[dateIdx]).endOf('month').format('DD');
        },

        acceptOffer() {
            let payment = {...this.payment};

            if (this.payment.frequency === 'monthly' && this.paymentDateIsLastDayOfMonth(1)) {
                payment.frequency = 'end-of-month';
            }

            this.$emit('accept', payment);
        },

        getPaymentAmount(amount) {
            if (!this.firstPaymentOffer) return amount;

            let reductionDollarValue = this.pdoConfig.dollar_amount_off;
            let reductionPercentage = this.pdoConfig.percent_off;
            let reductionDirection = this.pdoConfig.lower_or_higher;

            if (reductionDirection === 'lower' && reductionDollarValue < (amount * reductionPercentage)) {
                return amount - reductionDollarValue; // dollar reduction
            }

            if (reductionDirection === 'lower' && reductionDollarValue > (amount * reductionPercentage)) {
                return amount * (1 - reductionPercentage); // percent reduction
            }

            if (reductionDirection === 'higher' && reductionDollarValue < (amount * reductionPercentage)) {
                return amount * (1 - reductionPercentage); // percent reduction
            }

            if (reductionDirection === 'higher' && reductionDollarValue > (amount * reductionPercentage)) {
                return amount - reductionDollarValue; // dollar reduction
            }

            return amount;
        },

        setupSortedOffers() {
            if (this.offers && this.offers.length) {
                this.sortedOffers = this.offers;
            } else if (this.offer) {
                if (this.offer.settlement_allowed) {
                    this.sortedOffers = [
                        {
                            ...this.offer,
                            ...{
                                name: 'settlement',
                                type: 'settlement',
                                plan: this.offer,
                                subtext: 'Fewer Payments, Bigger Discount!'
                            }
                        }
                    ];
                } else {
                    this.sortedOffers = [
                        {
                            name: 'full',
                            type: 'full',
                            payment: this.offer.full,
                            plan: this.offer,
                            subtext: 'Fast-Track Payoff!'
                        }
                    ];
                }

                this.sortedOffers.push({
                    name: 'early-no-thanks',
                    type: 'early-no-thanks',
                });
            }
        },

        paymentCountGenerator(start, stop) {
            let generated = [];

            for (let i = start; i <= stop; i++) {
                generated.push(i);
            }

            return generated;
        },

        pdoString(paymentCount) {
            let string = '';

            if (this.pdoConfig.lower_or_higher === 'lower') {
                if (this.pdoConfig.dollar_amount_off < (this.paymentAmountFromCount(paymentCount) * this.pdoConfig.percent_off)) {
                    string = `$${this.pdoConfig.dollar_amount_off}`;
                } else {
                    string = `${this.pdoConfig.percent_off * 100}%`;
                }

                string += ' off first payment';
            } else if (this.pdoConfig.lower_or_higher === 'higher') {
                if (this.pdoConfig.dollar_amount_off > (this.paymentAmountFromCount(paymentCount) * this.pdoConfig.percent_off)) {
                    string = `$${this.pdoConfig.dollar_amount_off}`;
                } else {
                    string = `${this.pdoConfig.percent_off * 100}%`;
                }

                string += ' off first payment';
            }

            return string;
        },

        paymentAmountFromCount(count) {
            let amount = this.selectedOffer.offer
                || this.selectedOffer.amount
                || this.selectedOffer.payment;

            if (this.selectedOffer.type === 'custom') {
                amount = this.payment.amount;
            }

            if (count === 1) {
                return amount;
            }

            if (this.selectedOffer && count) {
                if (this.selectedOffer.hasOwnProperty('down_payment')) {
                    amount -= this.selectedOffer.down_payment;
                }

                return amount / count;
            }
        },

        shouldShowFee() {
            if (this.payment.type === 'card') {
                return this.payment.cc_number && this.payment.zip;
            }

            return this.payment.routing_number && this.payment.account_number;
        }
    }
}
</script>
